/**
* Created by vouill on 1/3/18.
*/

<template>
  <svg
    :class="{rotate: rotate}"
    width="34px"
    height="34px"
    viewBox="0 0 34 34"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs/>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="square">
      <g
        id="Desktop"
        transform="translate(-16.000000, -10.000000)"
        stroke="#FF9942"
        stroke-width="4">
        <g
          id="Group-2"
          transform="translate(19.000000, 13.000000)">
          <path
            d="M14.0921053,27.9078947 L27.9078947,14.0921053"
            id="Line-3"/>
          <path
            d="M27.9078947,13.9078947 L21.0921053,0.0921052632"
            id="Line-4"/>
          <path
            d="M21,0 L15,5"
            id="Line-5"/>
          <path
            d="M13.9102564,4.90384615 L7.08974359,0.0961538462"
            id="Line-6"/>
          <path
            d="M6.90789474,0.0933333333 L0.0921052632,13.9066667"
            id="Line-7"/>
          <path
            d="M1,15 L13.9111842,27.9102564"
            id="Line-8"/>
        </g>
      </g>
    </g>
  </svg>
</template>

<style scoped>
svg:hover {
  cursor: url(../../assets/fox.png) 16 16, auto;
}

.rotate {
  animation-name: rotate;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<script>
export default {
  name: "MetisLogo",
  props: { rotate: Boolean }
};
</script>
